import { render, staticRenderFns } from "./DailyPatrolPointDataChart.vue?vue&type=template&id=1b2a8850&scoped=true"
import script from "./DailyPatrolPointDataChart.vue?vue&type=script&lang=js"
export * from "./DailyPatrolPointDataChart.vue?vue&type=script&lang=js"
import style0 from "./DailyPatrolPointDataChart.vue?vue&type=style&index=0&id=1b2a8850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a8850",
  null
  
)

export default component.exports